import { useState, useEffect } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import { Button, InputSelect, PopOver } from '@wajeez-web/components/ui';
import {
  ReportProblemActions,
  useCustomerSelector,
} from '@wajeez-web/stores/customers';
import { PlusIcon } from '@heroicons/react/solid';
import { HandleTableData } from '@wajeez-web/components/data-table';
import { useCommonDispatch } from '@wajeez-web/stores/common';
import { contentEntityDataType } from '@wajeez-web/stores/content';
import { CheckBoxType } from '@wajeez-web/components/mui';
import { DataTableWrapper } from '@wajeez-web/components/helpers';

import ProblemOptionsModal from '../components/ProblemOptionsModal';
import AnswerReportProblemModal from '../components/AnswerReportProblemModal';

const ReportProblemPage = () => {
  const dispatch = useCommonDispatch();

  const [problemOptionModalState, setProblemOptionModalState] = useState({
    open: false,
  });
  const [answerReportProblemModalState, setAnswerReportProblemModalState] =
    useState<{ open: boolean; data?: string; id?: number }>({
      open: false,
    });
  const [selectedOption, setSelectedOption] = useState('');

  const { data, status, options } = useCustomerSelector(
    (state) => state.reportProblem
  );

  const { tablePreferances, setTablePreferences, isTableReferencesLoading } =
    HandleTableData(
      'reportProblem',
      ReportProblemActions.getAllReportProblemAsDataTableAsync
    );

  useEffect(() => {
    dispatch(ReportProblemActions.getAllReportProblemOptionsAsync());
  }, [dispatch]);

  return (
    <div className="h-full">
      <PageLayoutsContainer
        title={`Report Problem`}
        withoutRightPadding={false}
        endSideComponent={[
          {
            element: (
              <Button
                title={'Add New Problem Option'}
                Icon={PlusIcon}
                onClick={() => {
                  setProblemOptionModalState({ open: true });
                }}
                bg="primary"
                color="white"
              />
            ),
            permission: ['75.2', '75', '3', '75', '4', '75.1'],
          },
        ]}
        breadCrumbsLinks={[{ title: 'Report-Problem' }]}
      >
        <DataTableWrapper
          data={data as contentEntityDataType}
          onHeaderManage={(header) => {
            const flags = header
              ?.filter((h) => h.selected)
              .reduce(
                (previousValue: number, currentValue: CheckBoxType) =>
                  previousValue + Number(currentValue.value),
                0
              );

            tablePreferances &&
              flags &&
              setTablePreferences({
                ...tablePreferances,
                flags: flags + 1,
              });
          }}
          onPaginationChange={(pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                pageSize: pagination.pageSize,
              });
          }}
          sort={tablePreferances?.sortingOperations?.[0]}
          onSort={(sort) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                sortingOperations: [sort],
              });
          }}
          onFilter={(filters, pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                filteringOperations: filters.map((f) => {
                  return {
                    property: Number(f.key),
                    cretiria: f.value,
                    comparisonType: f.operator,
                  };
                }),
              });
          }}
          isLoading={status === 'loading'}
          preferences={tablePreferances || undefined}
          setPreferences={setTablePreferences}
        />
      </PageLayoutsContainer>
      {problemOptionModalState.open && (
        <ProblemOptionsModal
          isOpen={problemOptionModalState.open}
          onClose={() => setProblemOptionModalState({ open: false })}
        />
      )}
      {answerReportProblemModalState.open && (
        <AnswerReportProblemModal
          isOpen={answerReportProblemModalState.open}
          onClose={() => setAnswerReportProblemModalState({ open: false })}
          Q={answerReportProblemModalState.data || ''}
          // onSubmit={async (answer) => {
          //   const res = await dispatch(
          //     ReportProblemActions.answerReportProblemAsync({
          //       answer,
          //       reportProblemId: answerReportProblemModalState.id || 0,
          //     })
          //   );
          //   if (res.meta.requestStatus === 'fulfilled') {
          //     setAnswerReportProblemModalState({ open: false });
          //     getData();
          //   }
          // }}
        />
      )}
    </div>
  );
};

export default ReportProblemPage;
